import { getAccHostname } from '@adsk/acs-sc-web-platform-api';
import { PRODUCT_IDS } from '@adsk/alloy-provider';

const getPhotoUrl = (projectId: string, photoId: string): string => {
  const accHostname = getAccHostname();
  const productId = PRODUCT_IDS.BUILD; // get the productId from useCurrentProductId hook if we add Photos to other products
  return `${accHostname}/${productId}/photos/projects/${projectId}/photos/${photoId}`;
};

export default getPhotoUrl;
